import axios from '@/axios'
import api from '@/api'
import config from '@/config'

export const contentService = {
  fetchRegionTranslations,
  fetchBackupTranslations
}

function fetchRegionTranslations(_region) {
  return axios.get(api.endpoints.CONTENT_API.REGION_TRANSLATIONS.replace('{region}', _region))
}

function fetchBackupTranslations(_region) {
  return axios.get(config.myMachinePath + '/translations/{region}.json'.replace('{region}', _region))
}
